import { memo } from 'react';

import { CheckboxCircleFill } from '@moniebook-web/icons/system/checkbox-circle-fill';

import styles from './business-item.module.scss';
import type { BusinessItemProps } from './types';

function BusinessItemComponent({
    name,
    branchesCount = 0,
    isCurrent,
    id,
    onSelectCurrentBusiness,
}: Readonly<BusinessItemProps>) {
    return (
        <button
            className='flex w-full items-center justify-between gap-16 rounded-lg px-8 py-10 transition-all delay-75 duration-300 last-of-type:mb-8 hover:bg-black/10 hover:transition-all hover:delay-150 hover:duration-300'
            type='button'
            onClick={() => {
                if (!isCurrent) {
                    onSelectCurrentBusiness(id, name);
                }
            }}>
            <div className='flex w-full gap-16'>
                <div
                    className={`flex size-40 items-center justify-center ${styles.avatar}`}>
                    <p className='font-semibold! text-14 text-grey-11!'>
                        {name?.charAt(0)}
                    </p>
                </div>
                <div className='flex flex-col items-start'>
                    <p className='font-semibold! text-14 text-neutral-s14!'>
                        {name}
                    </p>
                    <p className='font-medium! text-14 text-neutral-s10!'>
                        {branchesCount}
                        {branchesCount > 1 ? 'Branches' : 'Branch'}
                    </p>
                </div>
            </div>

            {isCurrent && (
                <span
                    title='Current Business'
                    className='flex items-center justify-end'>
                    <CheckboxCircleFill className='flex justify-self-end' />
                </span>
            )}
        </button>
    );
}

export const BusinessItem = memo(BusinessItemComponent);
